import dayjs from '../../../../utils/dayjsConfig'
import { buildActivityTableRows } from '../activityBreakdownFilters'
import { routeBusinessLines } from './routeExecutionPdfBuilder'
import { activityLocationUrl, buildActivityExportSummary } from './activityBreakdownPdfBuilder'

export const ACTIVITY_CSV_HEADERS = [
  'Fecha y hora',
  'Código de cliente',
  'Cliente',
  'Actividad',
  'Motivo/Descripción',
  'Monto',
  'Dentro de geocerca',
  'Código de actividad',
  'Latitud',
  'Longitud',
  'Ubicación'
]

export const buildActivityCsvTableRows = (rows = []) => [
  ACTIVITY_CSV_HEADERS,
  ...rows.map((row) => [
    row.createdDateLabel,
    row.clientUid,
    row.clientName,
    row.activityLabel,
    row.motiveText,
    row.totalLabel,
    row.geofenceLabel,
    row.rawRow?.activity_uid ?? '-',
    row.isLiquidation ? '-' : (row.rawRow?.latitude ?? '-'),
    row.isLiquidation ? '-' : (row.rawRow?.longitude ?? '-'),
    activityLocationUrl(row) || '-'
  ])
]

export const buildActivityBreakdownCsvRows = ({
  results = [],
  overview,
  effectivenessSegment,
  formatActivityName = (name) => name,
  business,
  salesmanName,
  salesmanCode,
  startDate,
  endDate
}) => {
  const { kpis, totals } = buildActivityExportSummary(overview, effectivenessSegment)
  return [
    ['REPORTE:', 'Desglose de actividades'],
    ...routeBusinessLines(business).map((line) => [line]),
    ['USUARIO:', [salesmanCode, salesmanName].filter(Boolean).join(' - ') || 'N/A'],
    [
      'PERÍODO:',
      `${dayjs(startDate).format('DD/MM/YYYY')} - ${dayjs(endDate).format('DD/MM/YYYY')}`
    ],
    ['GENERADO:', dayjs().format('DD/MM/YYYY HH:mm:ss')],
    [],
    ['KPI', 'VALOR'],
    ...kpis.flatMap((card) => [
      [card.title, card.value],
      [card.subtitle],
      ...card.metrics,
      [card.footer]
    ]),
    ...totals.map((card) => [card.title, card.value, card.footer]),
    [],
    ...buildActivityCsvTableRows(buildActivityTableRows(results, formatActivityName)),
    ...(results.length
      ? []
      : [['No hay resultados', ...Array(ACTIVITY_CSV_HEADERS.length - 1).fill('')]])
  ]
}
